import { render, staticRenderFns } from "./AvatarChipNew.vue?vue&type=template&id=bc3f450a&scoped=true&functional=true&"
import script from "./AvatarChipNew.vue?vue&type=script&lang=js&"
export * from "./AvatarChipNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "bc3f450a",
  null
  
)

export default component.exports